import { GeneratorType } from "../../../types/api.types";
import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";
import type { GeneratorCreateFormData } from "./CreateFormStep.types";

export const FORM_FIELD_DATA = {
  name: {
    name: "name",
    label: "Bezeichnung",
    type: "text",
    required: true,
    helpText: "Frei wählbar, wird nur zur Identifikation verwendet"
  },
  type: {
    name: "type",
    label: "Typ",
    type: "select",
    required: true,
    data: [
      { value: GeneratorType.EEGAnlageSolar, label: "Photovoltaik" },
      {
        value: GeneratorType.EEGAnlageBiomasse,
        label: "Biomasse (fest, flüssig, gasförmig) - EEG"
      },
      { value: GeneratorType.EEGAnlageWind, label: "Windkraft" },
      { value: GeneratorType.EEGAnlageWasser, label: "Wasserkraft" },
      {
        value: GeneratorType.EEGAnlageGSGK,
        label: "Geothermie, Solarthermie, Grubengas, Klärschlamm (GSGK) - EEG"
      },
      {
        value: GeneratorType.KWKAnlageVerbrennung,
        label: "KWK fossil (u. a. Erdgas-BHKW)"
      },
      {
        value: GeneratorType.KWKAnlageBiomasse,
        label: "Biomasse - nicht EEG"
      },
      {
        value: GeneratorType.KWKAnlageGSGK,
        label:
          "Geothermie, Solarthermie, Grubengas, Klärschlamm (GSGK) - nicht EEG"
      },
      { value: GeneratorType.Sonstige, label: "Sonstige" }
    ]
  },
  person: {
    name: "person",
    label: "Betreiber",
    type: "select",
    required: true,
    helpText:
      "Hier bitte das Unternehmen eintragen, welches Betreiber der Stromerzeugungsanlage ist",
    data: []
  },
  connection: {
    name: "connection",
    label: "Netzverknüpfungspunkt",
    type: "select",
    required: true,
    data: []
  },
  bruttoleistung: {
    name: "bruttoleistung",
    label: "Bruttoleistung",
    type: "number",
    required: true
  },
  installedCapacity: {
    name: "installedCapacity",
    label: "Nettonennleistung",
    type: "number",
    required: true,
    min: 0
  },
  commissioning: {
    name: "commissioning",
    label: "Inbetriebnahme",
    type: "date",
    required: true
  },
  decommissioning: {
    name: "decommissioning",
    label: "Außerbetriebnahme",
    type: "date"
  }
} as const satisfies {
  [key in keyof GeneratorCreateFormData]?: FormInputData<
    GeneratorCreateFormData,
    key
  >;
};

export const DEFAULT_VALUES: GeneratorCreateFormData = {
  name: "",
  type: null,
  person: null,
  connection: null,
  bruttoleistung: null,
  installedCapacity: null,
  commissioning: null,
  decommissioning: null
};
